import { render, staticRenderFns } from "./addon-item.vue?vue&type=template&id=0b2fe9ce&"
import script from "./addon-item.vue?vue&type=script&lang=js&"
export * from "./addon-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports